import request from '@/utils/request'

export function getCascadeChinaZones() {
  const url = `zone/cascade_china_zones`
  return request({ url: url, method: 'get' })
}
